// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';
import { classify } from './utils/helpers';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
// import './utils/polyfills'; (includes Array.findIndex && Array.find)

// utils & data
import data from './data/data.json';

// styles
import './styles/graphic.scss';
import meta from './data/meta.json';

const messageTimeouts = [];

const pkg = require('../package.json');

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

function draw() {
  const container = select('#graphics-container').html('');

  // Group data by frame number
  const frames = {};
  data.forEach((row) => {
    if (!frames[row.frame]) {
      frames[row.frame] = []; // Initialize array for each frame
    }
    frames[row.frame].push(row);
  });

  // Loop through each frame and render it as a separate `.graphic` block
  Object.keys(frames).forEach((frameIndex, i, arr) => {
    const frameData = frames[frameIndex];

    // Create a new graphic container for each frame
    const graphic = container.append('div')
      .attr('class', `graphic graphic-${frameIndex}`);

    // Create a frame inside the graphic
    const frame = graphic.append('div')
      .attr('class', `frame frame-${frameIndex}`)
      .attr('data-frame', frameIndex);

    const header = frame.append('div')
      .attr('class', 'header');

    header.append('img')
      .attr('class', 'photo')
      .attr('src', './img/group_chat_icon.png');

    const senderName = frameData.find(d => d.speaker === 'sender');

    if (senderName) {
      header.append('span')
        .attr('class', 'sender-name')
        .html(senderName.content);
    }

    const thread = frame.append('div');

    frameData.forEach((row) => {
      if (row.type == 'timestamp') {
        thread.append('div')
          .attr('class', 'timestamp')
          .append('h3')
          .html(row.content);
      }

      if (row.type == 'message') {
        const message = thread.append('div')
          .attr('class', `message ${classify(row.speaker)}`)
          .style('position', 'relative');

        message.append('p')
          .html(row.content);

        message.append('div')
          .attr('class', `tri-right ${classify(row.speaker) === 'sender' || classify(row.speaker) === 'third-person' ? 'btm-left-in' : 'btm-right-in'}`);
      }

      // if (row.type == 'name') {
      //   thread.append('div')
      //     .attr('class', `name ${classify(row.speaker)}`)
      //     .append('p')
      //     .html(row.content);
      // }
    });

    if (i < arr.length - 1) {
      container.append('div')
        .attr('class', 'separator')
        .append('p')
        .html('Two days later, Lizzie allegedly texted Sarah after a conversation with David Teddy, the family attorney.');
    }
  });

  animateMessages();

  // balanceText('.message > p');
}


function animateMessages() {
  const messages = document.querySelectorAll('.message');
  messages.forEach((msg, i) => {
    const timeoutId = setTimeout(() => {
      msg.classList.add('visible');
    }, i * 500);
    // console.log(timeoutId, window.messageTimeouts);
    messageTimeouts.push(timeoutId);
  });
}

function resetMessages() {
  const messages = document.querySelectorAll('.message');
  // Clear all pending timeouts
  messageTimeouts.forEach(timeoutId => clearTimeout(timeoutId));
  messageTimeouts.length = 0;

  messages.forEach((msg) => {
    msg.classList.remove('visible');
  });
}

const root = document.getElementById('root');
const observer = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting == true) {
      resetMessages();
      animateMessages();
    }
  });
}, {
  root: null, // viewport
  threshold: [0, 1],
});

observer.observe(root);
